import React from 'react'
import { FormProvider } from 'react-hook-form'

import { MultiStepFormContext } from '~shared/components/reactHookForm/MultiStepForm/MultiStepFormContext'
import { FormContext } from '~shared/components/reactHookForm/FormContext'
import { MultiStepFormProps } from '~shared/components/reactHookForm/MultiStepForm/useMultiStepForm'
import GridContainer from '~shared/components/MuiGrid/GridContainer'
import { isDebugEnv } from '~config/envConfig'
import { DevTool } from '@hookform/devtools'
import { RhfDebugHelper } from '~shared/components/reactHookForm/RhfDebugHelper/RhfDebugHelper'
import { useMediaQuery, useTheme } from '@mui/material'

const MultiStepForm: React.FC<MultiStepFormProps> = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return <MultiStepFormContext.Provider value={props.multiStepFormContextValues}>
    <FormContext.Provider value={props.formContextProps}>
      <FormProvider {...props.methods}>
        <form
          noValidate // disable html validation in favor of yup
          onSubmit={props.methods.handleSubmit(props.onSubmitStep)}
          style={isMobile ? {} : { paddingLeft: '70px' }}
        >
          {/* {isDebugEnv && <RhfDebugHelper />} */}
          <GridContainer className={props.className} gridSpacing={2} defaultColWidth={6} maxWidth='Md' roundCornersTop roundCornersBottom>
            {props.children}
          </GridContainer>
        </form>
      </FormProvider>
    </FormContext.Provider>
  </MultiStepFormContext.Provider>
}

export default MultiStepForm
